import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@cimpress/react-components';

import '../css/imageSelection.css';

import UploadButton from './UploadButton';

const images = [
    {
        value: 'https://dev.scenes.documents.cimpress.io/v2/merchants/SceneTestGroup/compositions/e22a575d-c8a5-4784-bb33-32dd4f44ea8f/assets/35411c73-b4f8-41b2-9325-f549c549518b',
        label: 'Pig',
        width: 236,
        height: 236,
    },
    {
        value: 'https://dev.scenes.documents.cimpress.io/v2/merchants/SceneTestGroup/compositions/8f9885df-c611-4a1d-9997-2a63c2aeecf3/assets/5c594238-946c-43ce-810e-639712e12dab',
        label: 'Olympics',
        width: 2000,
        height: 1000,
    },
    {
        value: 'https://dev.scenes.documents.cimpress.io/v2/merchants/SceneTestGroup/compositions/4f688d2f-72a9-4b39-a4d9-44492e90a33f/assets/bc0fc243-3336-4f26-afc4-07a933f3e280',
        label: 'Christmas Cat',
        width: 1080,
        height: 720,
    },
    {
        value: 'https://dev.scenes.documents.cimpress.io/v2/merchants/SceneTestGroup/compositions/9dd3baf7-ec0a-4146-8210-48317709144c/assets/c2bb64ba-4a9e-4d9e-ba79-a269981d0309',
        label: 'Buildings',
        width: 555,
        height: 520,
    },
    {
        value: 'https://scenes.documents.cimpress.io/v2/merchants/test-merchant-group1/compositions/1b257140-fe28-4e9e-aa9b-b7114bea9079/assets/e25293be-9948-42fc-a638-c3e9e15e53e5',
        label: 'Cimpress Logo',
        width: 170,
        height: 130,
    },
    {
        value: 'https://dev.scenes.documents.cimpress.io/v2/merchants/SceneTestGroup/compositions/f7c6934d-5845-44cd-837f-d7491f9759de/assets/eb915ee5-f778-459f-b31a-6de346f0d9d0',
        label: 'Lion Cat',
        width: 996,
        height: 1245,
    },
];

const getSizeObject = (url) => {
    const { width, height } = images.find(image => image.value === url);
    return { url, width, height };
};

const ImageSelection = ({ image, onSelectImage, getSize }) => (
    <div className='image-control'>
        <Select
            label='Choose an image to try'
            className='image-control__select'
            value={image}
            onChange={newImage => onSelectImage(getSize ? getSizeObject(newImage) : newImage)}
            simpleValue={true}
            tether={true}
            options={images}
        />
        OR
        <UploadButton uploaded={false} className='image-control__upload' buttonType='primary' onUpload={onSelectImage} getSize={getSize} label='Upload your own' />
    </div>
);

export default ImageSelection;

ImageSelection.propTypes = {
    onSelectImage: PropTypes.func.isRequired,
    image: PropTypes.string,
    getSize: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/imageSelection.jsx